import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next"
import { ActionModal } from "../modals/ActionModal";
import { CustomModal } from "../CustomModal";
import { MDBBtn } from "mdb-react-ui-kit";
import { Portal } from "react-portal";

export interface MachineActionProps {
    action: any|null;
    onDone: () => Promise<void>;
    onClose?: () => void;
    autoOpen?: boolean;
    children?: (open: () => void) => React.ReactNode;
}
export const MachineAction = ({
    action,
    onDone,
    onClose,
    autoOpen,
    children
}: MachineActionProps) => {
    const { t } = useTranslation();
    const popups = useMemo(() =>
        Object
            .keys(action?.confirmation || {})
            .map(key => ({
                id: key,
                title: t(key),
                description: t(action.confirmation[key].description),
                style: action.confirmation[key].style || null,
                timeOut: action.confirmation[key].timeOut || null,
                button: t(action.confirmation[key].button ?? 'confirm')
            }))
    , [action, t]);
    const [shownPopups, setShownPopups] = useState<{[idx: number]: boolean}>({});
    const [error, setError] = useState('');

    const performAction = useCallback(async () => {
        try {
            await onDone();
        }catch(err: any){
            alert(err.message);
        }
    }, [onDone]);

    const closePopup = useCallback((idx: number) => {
        setShownPopups(prev => ({...prev, [idx]: false}));
    }, []);

    const showPopup = useCallback((idx: number) => {
        setShownPopups(prev => ({...prev, [idx]: true}));
    }, []);

    const cancel = useCallback(() => {
        setShownPopups({});
    }, []);

    
    const onPopupConfirm = useCallback(async (idx: number) => {
        closePopup(idx);
        if (idx < popups.length - 1) showPopup(idx+1);
        else performAction();
    }, [popups]);

    const open = useCallback(() => {
        if (popups.length == 0) performAction();
        else showPopup(0);
    }, [popups]);

    useEffect(() => {
        if (autoOpen) open();
    }, [autoOpen]);

    return (
        <>
            <Portal>
                {popups.map((p, idx) => (
                    <CustomModal
                        key={p.id}
                        open={shownPopups[idx]}
                        title={p.title}
                        // onCloseFinished={onPopupClose}
                        onClose={() => closePopup(idx)}
                        footer={(
                            <>
                                <MDBBtn color="secondary" onClick={() => closePopup(idx)}>{t('cancel')}</MDBBtn>
                                <MDBBtn color="danger" onClick={() => onPopupConfirm(idx)}>{p.button || t('confirm')}</MDBBtn>
                            </>
                        )}
                    >
                        <span>{p.description}</span>
                    </CustomModal>
                ))}
            </Portal>

            {(!autoOpen && children) && children(open)}
        </>
    )
}